import { Loader } from './Loader';

export const shoulderTypesLoader: { (token?: string): Loader } = (token) => new Loader(token);
